import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import { EndMarkerLabel } from 'automation-ui-canvas/components/common/EndMarkerLabel';
import UIIcon from 'UIComponents/icon/UIIcon';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WorkflowEndedPreview = ({
  flow,
  prevActionId,
  timestamp
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("div", {
      className: "simulated-action-accordion",
      children: /*#__PURE__*/_jsx(UIExpandableSection, {
        Caret: 'div',
        titleText: /*#__PURE__*/_jsx(EndMarkerLabel, {
          flow: flow,
          prevActionId: prevActionId
        }),
        actions: /*#__PURE__*/_jsxs(_Fragment, {
          children: [timestamp && /*#__PURE__*/_jsx(Text, {
            as: "small",
            marginInlineEnd: "200",
            children: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
              value: timestamp,
              format: "l LT z"
            })
          }), /*#__PURE__*/_jsx(UIIcon, {
            name: "contactProperties",
            size: "xxs",
            className: "p-x-2"
          })]
        })
      })
    })
  );
};